export const stripHTMLFromString = (htmlString: string): string => {
  const doc = new DOMParser().parseFromString(htmlString, "text/html");
  return doc.body.textContent || "";
};
